import styled, { keyframes, css } from 'styled-components';
import Icon from '../Icon/Icon.js';

// @ts-nocheck
var fadeIn = keyframes(["from{opacity:0;}to{opacity:0.2;}"]);
var fadeInReverse = keyframes(["from{opacity:0.2;}to{opacity:0;}"]);
var Wrapper = styled.dialog.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-n1o02j-0"
})(["display:none;box-shadow:0px -3px 19.6px rgba(0,0,0,0);transform:translateY(100%);transition:transform 0.4s ease,box-shadow 0.4s ease;width:100%;position:fixed;bottom:0;margin-left:auto;margin-right:auto;background:#fff;max-height:100vh;max-width:1150px;padding:4.8rem 0 0;border-radius:24px 24px 0 0;overflow:hidden;top:unset;&::backdrop{background:#000;opacity:0.2;}", " ", " ", " ", " &.fullscreen{border-radius:0;}"], function (_ref) {
  var $noHeader = _ref.$noHeader;
  return $noHeader && css(["padding-top:2.4rem;"]);
}, function (_ref2) {
  var $display = _ref2.$display;
  return $display && css(["display:block;&::backdrop{opacity:0.2;animation-name:", ";animation-duration:0.4s;}"], fadeIn);
}, function (_ref3) {
  var $open = _ref3.$open;
  return $open && css(["transform:translateY(0%);box-shadow:0px -3px 19.6px rgba(0,0,0,0.12);"]);
}, function (_ref4) {
  var $hide = _ref4.$hide;
  return $hide && css(["&::backdrop{opacity:0;animation-name:", ";animation-duration:0.4s;}"], fadeInReverse);
});
var Header = styled.div.withConfig({
  displayName: "style__Header",
  componentId: "sc-n1o02j-1"
})(["display:flex;justify-content:center;position:absolute;top:2.4rem;width:100%;"]);
var Handle = styled.div.withConfig({
  displayName: "style__Handle",
  componentId: "sc-n1o02j-2"
})(["cursor:grab;user-select:none;padding:15px;margin-top:-15px;span{height:2px;width:140px;display:block;background:var(--color-text);}"]);
var CloseButton = styled.button.withConfig({
  displayName: "style__CloseButton",
  componentId: "sc-n1o02j-3"
})(["display:", ";position:absolute;top:-5px;right:19px;"], function (_ref5) {
  var $show = _ref5.$show;
  return $show ? 'block' : 'none';
});
var CloseButtonIcon = styled(Icon).withConfig({
  displayName: "style__CloseButtonIcon",
  componentId: "sc-n1o02j-4"
})(["display:block;"]);

export { CloseButton, CloseButtonIcon, Handle, Header, Wrapper };
//# sourceMappingURL=style.js.map
